import { render, staticRenderFns } from "./qinZiYuan.vue?vue&type=template&id=105e712f&scoped=true"
import script from "./qinZiYuan.vue?vue&type=script&lang=js"
export * from "./qinZiYuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e712f",
  null
  
)

export default component.exports